export const createReplacePayload = (signatories, isSequential) => {
  return signatories.map((signatory) => ({
    SignatureSequence: !isSequential ? 1 : signatory.SignatureSequence ?? signatory?.sequence,
    UserId: signatory?.UserId,
    Email: signatory?.Email ?? signatory?.email,
    roleName: signatory.Name ? signatory.Name.replace(' (Me)', '') : signatory?.customName,
    isReplaced: signatory.isReplaced,
    OldSignerId: signatory.isReplaced ? signatory?.signatoryId : null,
  }));
};
